import { updatePublicKeysInDtos } from '@/shared/lib/helpers/scenario';
import { SJDatabase } from '@/shared/lib/sj-orm/core';
import { CollectionName } from '@/shared/lib/sj-orm/types';
import { log } from '@/shared/utils/log';

import { BeneficiariesDataMap } from './getBeneficiariesDataMap';

export const updateScenarioCollectionItemsPublicKeys = async ({
  sjDb,
  beneficiariesDataMap,
  relatedDtoIdsMap,
}: {
  sjDb: SJDatabase;
  beneficiariesDataMap: BeneficiariesDataMap;
  relatedDtoIdsMap: Map<CollectionName, string[]>;
}) => {
  const beneficiariesIdsList = Object.keys(beneficiariesDataMap);

  const beneficiariesDataList = beneficiariesIdsList
    .map((dtoId) => {
      const beneficiary = beneficiariesDataMap[dtoId];

      if (!beneficiary) {
        log.error('Missing beneficiary');
        return undefined;
      }

      if (!beneficiary.publicKey) {
        log.error('Missing beneficiary publicKey');
        return undefined;
      }

      const centralDbId = beneficiary.centralDbId;
      const publicKey = beneficiary.publicKey;

      return { centralDbId, dtoId, publicKey };
    })
    .filter((el) => el !== undefined);

  const promisesList = beneficiariesDataList.map((beneficiaryData) => {
    const relatedItemsPermissionsPromise = updatePublicKeysInDtos({
      dtoIdsMap: relatedDtoIdsMap,
      publicKey: beneficiaryData.publicKey,
      sjDb,
    });

    return relatedItemsPermissionsPromise;
  });

  await Promise.allSettled(promisesList);
};
